import { render, staticRenderFns } from "./VipProblemManager.vue?vue&type=template&id=a95943c2&scoped=true"
import script from "./VipProblemManager.vue?vue&type=script&lang=js"
export * from "./VipProblemManager.vue?vue&type=script&lang=js"
import style0 from "./VipProblemManager.vue?vue&type=style&index=0&id=a95943c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95943c2",
  null
  
)

export default component.exports